import { Box } from '@mui/material'
import { FooterProps } from './Footer.types'

const LINK_SX = {
  color: 'var(--brand-blue-600)',
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
} as const

/**
 * Copyright and the two legal links. 60px (`--footer-h`). Grids size
 * themselves to the content area above it (GridFrame), so its height is free.
 *
 * The links are real anchors, so they are keyboard-reachable and can be
 * middle-clicked. They were `Box role="link"` with a `window.open` handler and
 * no `href`.
 */
export const Footer = ({
  copyrightText,
  privacyText,
  privacyHref,
  cookiesText,
  cookiesHref,
}: FooterProps) => (
  <Box
    component="footer"
    sx={{
      height: 'var(--footer-h)',
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      background: 'var(--surface-0)',
      borderTop: '1px solid var(--line-200)',
      fontSize: 12,
      color: 'var(--ink-500)',
    }}
  >
    <span>
      &copy; 2009–{new Date().getFullYear()} SupplyVue Ltd. {copyrightText}.
    </span>
    <Box
      component="a"
      href={privacyHref}
      target="_blank"
      rel="noopener noreferrer"
      sx={LINK_SX}
    >
      {privacyText}
    </Box>
    <Box component="span" aria-hidden="true" sx={{ color: 'var(--line-300)' }}>
      |
    </Box>
    <Box
      component="a"
      href={cookiesHref}
      target="_blank"
      rel="noopener noreferrer"
      sx={LINK_SX}
    >
      {cookiesText}
    </Box>
  </Box>
)
